import type { Action } from 'redux';
import { combineReducers } from 'redux';
import { backTestReducer } from 'state/backTest/backTest.reducer';
import { blottersReducer } from 'state/blotters/blotter.reducer';
import { documentDownloadReducer } from 'state/document/reducer';
import { essentialFormReducer } from 'state/essential/reducer';
import { metadataReducer } from 'state/forms/metadata/reducer';
import { rejectionsReducer } from 'state/forms/rejections/reducer';
import { helpCenterReducer } from 'state/helpRequest/reducer';
import { missedDealFeedbackReducer } from 'state/missed-deal-feeedback/reducer';
import { monthlyExpiryDateCalendarsReducer } from 'state/monthlyExpiryDates/monthlyExpiryDates.reducer';
import { ordersBasketFormsReducer } from 'state/orders-basket/reducer';
import { scheduledRunReducer } from 'state/scheduledRuns/reducer';
import type { AppState } from 'state/state.model';
import { underlyingHistoReducer } from 'state/underlyingHistograph/underlyingHisto.reducer';
import { underlyingsDatesReducer } from 'state/underlyingsDates/underlyingsDates.reducer';
import { userReducer } from 'state/user/user.reducer';

import { addonFormReducer } from './addonForm/addonForm.reducer';
import { addonManagementFormReducer } from './addonManagementForm/addonManagementForm.reducer';
import { advisoryReducer } from './advisory/reducer';
import { appCrashReducer } from './appCrashed/appCrash.reducer';
import { batchFormReducer } from './batchForm/batchForm.reducer';
import { discoverReducer } from './discover/discover.reducer';
import { dynamicFormReducer } from './dynamic/dynamicForm.reducer';
import { emailServiceReducer } from './emailService/emailService.reducer';
import { formDataReducer } from './formData/formData.reducer';
import { userNotificationsReducer } from './notifications/notification.reducer';
import { productDescriptionReducer } from './product-description/reducer';
import { productModificationFormReducer } from './productModificationForm/productModificationForm.reducer';
import { productsReferentialReducer } from './productsReferential/productsReferential.reducer';
import { quotesReducer } from './quotes/quotes.reducer';
import { routerReducer } from './router';
import { secondaryMarketReducer } from './secondaryMarket/secondaryMarket.reducer';
import { SettlementDateCalendarsReducer } from './settlementDateCalendars/settlementDateCalendars.reducer';
import { staticFormReducer } from './static/staticForm.reducer';
import { tradeAllocationFormReducer } from './tradeAllocationForm/tradeAllocationForm.reducer';
import { tradesReducer } from './trades/trades.reducer';
import { UiPanelReducer } from './uiPanelState/reducer';
import { userConsentReducer } from './userConsent/userConsent.reducer';
import { userPreferencesReducer } from './userPreferences/userPreferences.reducer';
import { valuationDateCalendarsReducer } from './valuationDateCalendars/valuationDateCalendars.reducer';
import { workspacesReducer } from './workspaces/workspaces.reducer';
export const rootReducer = combineReducers<AppState, Action>({
  essential: essentialFormReducer,
  addonForm: addonFormReducer,
  addonManagementForm: addonManagementFormReducer,
  advisory: advisoryReducer,
  appCrash: appCrashReducer,
  batchForm: batchFormReducer,
  blotters: blottersReducer,
  discover: discoverReducer,
  dynamic: dynamicFormReducer,
  formData: formDataReducer,
  ordersBasket: ordersBasketFormsReducer,
  metadata: metadataReducer,
  monthlyExpiryDates: monthlyExpiryDateCalendarsReducer,
  missedDealFeedback: missedDealFeedbackReducer,
  productDescription: productDescriptionReducer,
  productModificationForm: productModificationFormReducer,
  productsReferential: productsReferentialReducer,
  quotes: quotesReducer,
  router: routerReducer,
  secondaryMarket: secondaryMarketReducer,
  settlementDateCalendars: SettlementDateCalendarsReducer,
  static: staticFormReducer,
  documentDownload: documentDownloadReducer,
  tradeAllocationForm: tradeAllocationFormReducer,
  trades: tradesReducer,
  uiPanel: UiPanelReducer,
  user: userReducer,
  userConsent: userConsentReducer,
  userNotifications: userNotificationsReducer,
  userPreferences: userPreferencesReducer,
  valuationDateCalendars: valuationDateCalendarsReducer,
  workspaces: workspacesReducer,
  emailService: emailServiceReducer,
  underlyingHistoModal: underlyingHistoReducer,
  backTest: backTestReducer,
  scheduledRun: scheduledRunReducer,
  helpCenter: helpCenterReducer,
  underlyingsDates: underlyingsDatesReducer,
  rejections: rejectionsReducer,
});
